import React, {FC, PropsWithChildren} from 'react';

export interface IHideableProps extends PropsWithChildren {
  hide?: boolean;
  show?: boolean;
}

// hides children unmounting them
const Hideable: FC<IHideableProps> = ({
	hide = false,
	show = !hide,
	children,
}) => {
	if (hide || !show) {
		return null;
	}

	return <>{children}</>;
};

export default Hideable;
